































helpers = require('../../helpers.coffee')

view_model =
  components:
    autocompleteGroup: require('../shared/autocomplete/group.vue')

  mixins: [
    require('../../mixins/users_options.coffee'),
    require('../../mixins/tags_options.coffee')
  ]

  props:
    filters:
      default: {}

    show_user_filter:
      default: true

    show_status_filter:
      default: true

    show_stage_filter:
      default: true
    
    show_tag_filter: 
      default: true

    show_group_filter:
      default: false

    show_lost_reason_filter:
      default: true

    label_clear_filter:
      default: true

    user_id:
      default: null

  data: ->
    filter_item_selected_ids: @filters['with_tags']
    uncheck_all_items: false
    kind_multiple_filter: 'tag_filter'
    status_filter: @statusFilter()
    pristine_filter: true
    base_filter_str: '{}'
    status_options: [
      { value: null, text: @$t('contacts.attributes.status.title') }
      { value: { active_status: true }, text: @$t('contacts.attributes.status.options.active') }
      { value: { bounced_status: true }, text: @$t('contacts.attributes.status.options.bounced') }
      { value: { connected_status: true }, text: @$t('contacts.attributes.status.options.connected') }
      { value: { uninitialized_status: true }, text: @$t('contacts.attributes.status.options.uninitialized') }
      { value: { paused_status: true }, text: @$t('contacts.attributes.status.options.paused') }
      { value: { converting_status: true }, text: @$t('contacts.attributes.status.options.converting') }
      { value: { scheduled_status: true }, text: @$t('contacts.attributes.status.options.scheduled')}
      { value: { interrupted_status: true }, text: @$t('contacts.attributes.status.options.interrupted') }
      { value: { blocklisted_status: true }, text: @$t('contacts.attributes.status.options.blocklisted') }
      { value: { not_connected_status: true }, text: @$t('contacts.attributes.status.options.notConnected') }
      { value: { disqualified_status: true }, text: @$t('contacts.attributes.status.options.disqualified') }
      { value: { inactive_status: true }, text: @$t('contacts.attributes.status.options.inactive') }
    ],

    stage_filter: @extractFilter('stage_eq')
    stage_options: [
      { value: null, text: @$t('contacts.attributes.stage.title') }
      { value: { stage_eq: 'smart_lead' }, text: @$t('contacts.attributes.stage.options.smartLead') }
      { value: { stage_eq: 'prospect' }, text: @$t('contacts.attributes.stage.options.prospect') }
      { value: { stage_eq: 'lead' }, text: @$t('contacts.attributes.stage.options.lead') }
      { value: { stage_eq: 'mql' }, text: @$t('contacts.attributes.stage.options.mql') }
      { value: { stage_eq: 'sql' }, text: @$t('contacts.attributes.stage.options.sql') }
      { value: { stage_eq: 'opportunity' }, text: @$t('contacts.attributes.stage.options.opportunity') }
      { value: { stage_eq: 'client' }, text: @$t('contacts.attributes.stage.options.client') }
      { value: { stage_eq: 'lost' }, text: @$t('contacts.attributes.stage.options.lost') }
    ],

    tag_filter: @extractFilter('with_tags')

    user_filter: @extractFilter('user_id_eq')

    lost_reason_filter: @extractFilter('lost_reason_id_eq')
    lost_reason_options: []

    group_filter: @extractFilter('contact_group_id_eq')
    group_options: [ value: null, text: 'Carregando...' ]

    text_field_filter: @filters.search_query

  computed:
    filterParams: ->
      filter_params = {}
      for filter in [@status_filter, @stage_filter, @tag_filter, @user_filter, @group_filter, @lost_reason_filter]
        Object.assign(filter_params, filter) if filter
      filter_params['search_query'] = @text_field_filter if @text_field_filter
      filter_params

  methods:
    lostReasonOptions: ->
      result = []
      result.push { value: null, text: @$t('general.label.lostReasons') }
      this.$store.dispatch('fetchLostReasons') if this.$store.getters.lostReasonsCount == 0
      for lost_reason in this.$store.getters.lostReasonsList
        result.push { value: { lost_reason_id_eq: lost_reason.id }, text: lost_reason.title }
      @lost_reason_options = result

    itemSelectedItems: (data)->
      @tag_filter =
        with_tags: data.selected_items.map (t)-> t.id

      @filter()

    filter: ->
      params = @filterParams
      @pristine_filter = @base_filter_str == JSON.stringify(params)
      @$emit('filter', params)

    clearFilter: ->
      return if @pristine_filter

      @pristine_filter      = true
      @tag_filter           = null
      @user_filter          = null
      @group_filter         = null
      @status_filter        = null
      @text_field_filter    = null
      @stage_filter = null

      @$emit('filter', {})
      @uncheck_all_items = !@uncheck_all_items

    statusFilter: ->
      filter_keys = Object.keys(@filters).join()
      return unless filter_keys.match(/_status/)

      status_filter = {}
      for type in ['active_status', 'paused_status', 'scheduled_status', 'bounced_status', 'inactive_status',
                   'connected_status', 'converting_status', 'interrupted_status', 'uninitialized_status',
                   'blocklisted_status', 'not_connected_status', 'disqualified_status']
        status_filter[type] = true if @filters[type]
      status_filter

    loadGroups: ->
      return unless @show_group_filter
      params = { q: {s: 'name asc'}, limit: 100 }
      params.q.user_id_eq = @user_id if @user_id
      new ContactGroupsResource(Session.current_company.id).index(@loadGroupsSuccess, null, params: params)

    loadGroupsSuccess: (data) ->
      @group_options = data.contact_groups.map (contact_group) ->
        { value: { contact_group_id_eq: contact_group.id.toString() }, text: contact_group.name }
      @group_options.unshift(value: null, text: 'Grupos')

    updateClearFilter: ->
      @pristine_filter = @base_filter_str == JSON.stringify(@filterParams) && !@$router.currentRoute.query.id_in

    updateGroup: (item) ->
      @group_filter = { contact_group_id_eq: item.id }
      @filter()

  watch:
    '$route': 'updateClearFilter'

  created: ->
    # @loadGroups()
    @lostReasonOptions()
    @updateClearFilter()

exports.default = helpers.vue_include(view_model, helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/filters.vue